<template>
  <div class="title">
    <h2 class="textOne">{{ span }}</h2>
    <h2 class="textTwo">{{ h }}</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {
      span: "La Plataforma",
      h: "Gestion.gob.cl",
    };
  },
};
</script>

<style scoped>
.title {
  display: flex;
  margin-left: 36px;
}

.textOne {
  color: #fff !important;
  font-weight: 200;
  margin-right: 10px;
  font-size: 39px;
}

.textTwo {
  color: #fff !important;
  font-size: 40px;
}

@media screen and (max-width: 1150px) {
  .textOne {
    font-size: 31px;
  }

  .textTwo {
    font-size: 32px;
  }
}

@media screen and (max-width: 960px) {
  .textOne {
    font-size: 21px;
  }

  .textTwo {
    font-size: 22px;
  }
}

@media screen and (max-width: 767px) {
  .textOne {
    font-size: 25px;
    margin-left: 130px;
  }

  .textTwo {
    font-size: 26px;
  }
}

@media screen and (max-width: 600px) {
  .textOne {
    font-size: 21px;
    margin-left: 110px;
  }

  .textTwo {
    font-size: 22px;
  }
}

@media screen and (max-width: 600px) {
  .textOne {
    font-size: 21px;
    margin-left: 110px;
  }

  .textTwo {
    font-size: 22px;
  }
}

@media screen and (max-width: 514px) {
  .textOne {
    font-size: 18px;
    margin-left: 50px;
  }

  .textTwo {
    font-size: 19px;
  }
}

@media screen and (max-width: 344px) {
  .textOne {
    font-size: 16px;
    margin-left: 10px;
  }

  .textTwo {
    font-size: 17px;
  }
}
</style>
